export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-v1-960-d800125c35ab4ae1c907c8c94ee69d9e.png";